/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialOnboardingProgressControllerFindForTrialQueryResponse, TrialOnboardingProgressControllerFindForTrialQueryParams, TrialOnboardingProgressControllerFindForTrial401, TrialOnboardingProgressControllerFindForTrial403 } from "../../models/trialOnboardingProgressController/TrialOnboardingProgressControllerFindForTrial";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trialOnboardingProgressControllerFindForTrial } from "../../clients/trial-onboarding-progressService/trialOnboardingProgressControllerFindForTrial";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trialOnboardingProgressControllerFindForTrialQueryKey = (params: TrialOnboardingProgressControllerFindForTrialQueryParams) => [{
  url: '/api/v1/trial-onboarding-progress'
}, ...(params ? [params] : [])] as const;
export type TrialOnboardingProgressControllerFindForTrialQueryKey = ReturnType<typeof trialOnboardingProgressControllerFindForTrialQueryKey>;
export function trialOnboardingProgressControllerFindForTrialQueryOptions(params: TrialOnboardingProgressControllerFindForTrialQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trialOnboardingProgressControllerFindForTrialQueryKey(params);
  return queryOptions<TrialOnboardingProgressControllerFindForTrialQueryResponse, ResponseErrorConfig<TrialOnboardingProgressControllerFindForTrial401 | TrialOnboardingProgressControllerFindForTrial403>, TrialOnboardingProgressControllerFindForTrialQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trialOnboardingProgressControllerFindForTrial(params, config);
    }
  });
}

/**
 * @summary Get trial onboarding progress for the current user
 * {@link /api/v1/trial-onboarding-progress}
 */
export function useTrialOnboardingProgressControllerFindForTrial<TData = TrialOnboardingProgressControllerFindForTrialQueryResponse, TQueryData = TrialOnboardingProgressControllerFindForTrialQueryResponse, TQueryKey extends QueryKey = TrialOnboardingProgressControllerFindForTrialQueryKey>(params: TrialOnboardingProgressControllerFindForTrialQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrialOnboardingProgressControllerFindForTrialQueryResponse, ResponseErrorConfig<TrialOnboardingProgressControllerFindForTrial401 | TrialOnboardingProgressControllerFindForTrial403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trialOnboardingProgressControllerFindForTrialQueryKey(params);
  const query = useQuery({
    ...trialOnboardingProgressControllerFindForTrialQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrialOnboardingProgressControllerFindForTrial401 | TrialOnboardingProgressControllerFindForTrial403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}